import { render, staticRenderFns } from "./date-picker-format-editor.vue?vue&type=template&id=b9ce4c3e&scoped=true"
import script from "./date-picker-format-editor.vue?vue&type=script&lang=js"
export * from "./date-picker-format-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ce4c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9ce4c3e')) {
      api.createRecord('b9ce4c3e', component.options)
    } else {
      api.reload('b9ce4c3e', component.options)
    }
    module.hot.accept("./date-picker-format-editor.vue?vue&type=template&id=b9ce4c3e&scoped=true", function () {
      api.rerender('b9ce4c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-date-picker/date-picker-format-editor.vue"
export default component.exports